<h2 mat-dialog-title>Teletrabajo de la semana {{ data.from | date: 'shortDate' }} - {{ data.to | date: 'shortDate' }}</h2>
<mat-dialog-content [formGroup]="form">
  <mat-checkbox formControlName="has_remote_work_monday">Lunes</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_tuesday">Martes</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_wednesday">Miércoles</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_thursday">Jueves</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_friday">Viernes</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_saturday">Sábado</mat-checkbox><br />
  <mat-checkbox formControlName="has_remote_work_sunday">Domingo</mat-checkbox><br />

  <mat-form-field appearance="outline" class="reason-field">
    <mat-label>Motivo del teletrabajo</mat-label>
    <textarea matInput formControlName="reason" placeholder="Explica por qué necesitas estos días"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" (click)="createRemoteWorkExceptionRequest()" [disabled]="form.invalid || saving()">
    <mat-icon>send</mat-icon>
    @if (saving()) {
      Enviando…
    } @else {
      Enviar petición
    }
  </button>
</mat-dialog-actions>
